import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Card, Heading } from "@icg360/design-system";

import { trackEvent, useFlags } from "utils";

import styles from "./featured-offers-ting.module.scss";

export const FeaturedOfferTing = () => {
  const { abTestTing, abTestTingFeaturedImage } = useFlags();
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent("Featured Offer Card Shown", {
      offerInternalName: "ting-offer",
    });
  });

  const imageFlagMap: Record<string, { url: string; alt: string }> = {
    Control: {
      url: "/assets/images/featured-offer-ting.jpg",
      alt: "Hand holding phone displaying Ting app",
    },
    Variation_A: {
      url: "/assets/images/featured-offer-ting-2.jpg",
      alt: "Holding newly-opened Ting sensor",
    },
  };
  const imageUrl =
    imageFlagMap[(abTestTingFeaturedImage ?? "Control") as string].url;
  const imageAlt =
    imageFlagMap[(abTestTingFeaturedImage ?? "Control") as string].alt;

  const copyFlagMap = {
    Control: "Help prevent electrical fires for free with Ting",
    Test_A: "Protect what matters most from electrical fires — for free",
  };

  return (
    <Card className={styles.cardDS}>
      <Heading size="md">Property services</Heading>
      <div className={styles.content}>
        <div className={styles.leftCopy}>
          <Heading size="lg" className={styles.heroTextDS}>
            {copyFlagMap[(abTestTing ?? "Control") as string]}
          </Heading>
          <Button
            onPress={() =>
              navigate(`/my/property-services/ting-offer`, {
                state: { from: "/my/overview" },
              })
            }
            data-testid="ting-featured-btn"
          >
            Sign up for Ting
          </Button>
        </div>
        <div
          className={styles.imageWrapper}
          role="img"
          aria-label={imageAlt}
          title={imageAlt}
          style={{
            backgroundImage: `url(${imageUrl})`,
          }}
        />
      </div>
    </Card>
  );
};
